import { ProjectSlimForList } from '../projects/types';
import {
  Actions,
  GET_CLIENTS,
  GET_CLIENTS_SUCCEEDED,
  CREATE_CLIENT,
  CREATE_CLIENT_SUCCEEDED,
  GET_INDUSTRIES_SUCCEEDED,
  DELETE_CLIENT,
  DELETE_CLIENT_SUCCEEDED,
  DELETE_CLIENT_FAILED,
  CREATE_CLIENT_FAILED,
  GET_CLIENT_SUCCEEDED,
  CLEAN_CLIENT_DETAIL,
  UPDATE_CLIENT_SUCCEEDED,
  UPDATE_CLIENT_FAILED,
  UPDATE_CLIENT,
  GET_PROJECTS_FOR_SELECTED_CLIENT_SUCCEEDED,
  GET_PROJECTS_FOR_SELECTED_CLIENT,
  GET_PROJECTS_FOR_SELECTED_CLIENT_FAILED,
} from './actions';
import { IClientsState } from './types';

const initialState: IClientsState = {
  detail: null,
  deleting: false,
  industries: [],
  list: {
    items: [],
    loading: false,
    queriedAtLeastOnce: false,
  },
  projectsForSelectedClientList: {
    items: [],
    loading: false,
    queriedAtLeastOnce: false,
    total: 0,
  },
  savingClient: false,
};

const reducer = (
  state: IClientsState = initialState,
  action: Actions
): IClientsState => {
  switch (action.type) {
    case CLEAN_CLIENT_DETAIL:
      return {
        ...state,
        detail: null,
        projectsForSelectedClientList: {
          ...initialState.projectsForSelectedClientList,
        },
      };

    case GET_CLIENT_SUCCEEDED:
      return {
        ...state,
        detail: action.payload.clientDetail,
      };

    case GET_CLIENTS:
      return {
        ...state,
        list: {
          ...state.list,
          items: action.payload.page === 1 ? [] : state.list.items,
          loading: true,
        },
      };

    case GET_CLIENTS_SUCCEEDED:
      return {
        ...state,
        list: {
          ...state.list,
          items: [...state.list.items, ...action.payload.clients],
          loading: false,
          queriedAtLeastOnce: true,
        },
      };

    case GET_INDUSTRIES_SUCCEEDED:
      return {
        ...state,
        industries: action.payload.industries,
      };

    case CREATE_CLIENT:
    case UPDATE_CLIENT:
      return {
        ...state,
        savingClient: true,
      };

    case CREATE_CLIENT_FAILED:
    case UPDATE_CLIENT_FAILED:
      return {
        ...state,
        savingClient: false,
      };

    case CREATE_CLIENT_SUCCEEDED:
      return {
        ...state,
        list: {
          ...state.list,
          items: [action.payload.client, ...state.list.items],
        },
        savingClient: false,
      };

    case UPDATE_CLIENT_SUCCEEDED:
      return {
        ...state,
        detail: action.payload.clientDetail,
        savingClient: false,
      };

    case GET_PROJECTS_FOR_SELECTED_CLIENT:
      return {
        ...state,
        projectsForSelectedClientList: {
          ...state.projectsForSelectedClientList,
          loading: true,
          items:
            action.payload.page === 1
              ? []
              : state.projectsForSelectedClientList.items,
        },
      };

    case GET_PROJECTS_FOR_SELECTED_CLIENT_SUCCEEDED:
      return {
        ...state,
        projectsForSelectedClientList: {
          ...state.projectsForSelectedClientList,
          queriedAtLeastOnce: true,
          loading: false,
          items: [
            ...state.projectsForSelectedClientList.items,
            ...action.payload.projects,
          ],
          total: action.payload.total,
        },
      };

    case GET_PROJECTS_FOR_SELECTED_CLIENT_FAILED:
      return {
        ...state,
        projectsForSelectedClientList: {
          ...state.projectsForSelectedClientList,
          loading: false,
          items: [] as ProjectSlimForList[],
          total: 0,
        },
      };

    case DELETE_CLIENT:
      return {
        ...state,
        deleting: true,
      };

    case DELETE_CLIENT_FAILED:
    case DELETE_CLIENT_SUCCEEDED:
      return {
        ...state,
        deleting: false,
      };

    default:
      return state;
  }
};

export default reducer;
